module.exports = __webpack_public_path__ + "media/components/assets/img/logo/sas-9965d749f21b6f5c6dd4f1e2f5a976c8.png";